<template>
  <el-dialog
    custom-class="create-page-pc"
    width='500px'
    title=""
    :visible.sync="dialogVisible"
    :before-close="stopPolling"
    top="0">
      <img class="background" :src="background" alt="">
      <div class="loading-qrcode" v-loading="loading">
        <img id="qr-code" :src="qrcode" alt="">
      </div>
  </el-dialog>
</template>
<script>
import { getQrcode, wechatPolling } from '@/api/index'
import background from '@/assets/open_dialog_pc.png'
export default {
  inject: ['reload'],
  props: {
    dialogVisible: Boolean
  },
  data () {
    return {
      qrcode: null,
      loading: true,
      background: background
    }
  },
  methods: {
    requestQrcode () {
      getQrcode()
        .then((data) => {
          this.qrcode = data.data.qrcode_img_url
          this.ticket = data.data.ticket
          this.loading = false
          // 每隔一秒轮询一次
          window.timer = setInterval(function () {
            wechatPolling({
              ticket: this.ticket
            })
              .then((data) => {
                if (data.data) {
                  clearInterval(window.timer)
                  let uid = data.data.user.homepage_uid
                  // 把 Authorization 存储在 localStorage 里面
                  localStorage.setItem('authorization', data.data.user.fc_md5rand)
                  if (uid > 0) {
                    // 跳转至我的主页页面
                    if (parseInt(uid) === parseInt(data.data.profile.id) && this.$route.name === 'Index') {
                      this.reload()
                    } else {
                      this.$router.push({name: 'Index', params: {id: data.data.profile.id}})
                    }
                    this.$emit('closeDialog')
                    this.$message({
                      message: '登录成功',
                      type: 'success'
                    })
                  } else {
                    this.$router.push({path: '/create', query: {ticket: this.ticket}})
                  }
                }
              })
              .catch((err) => { console.log(err) })
          }.bind(this), 1000)
        })
        .catch((err) => { console.log(err) })
    },
    stopPolling () {
      this.$emit('closeDialog')
      clearInterval(window.timer)
    }
  },
  watch: {
    dialogVisible: function (newValue, oldValue) {
      if (newValue === true) {
        this.requestQrcode()
      }
    }
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>
<style lang="scss">
  .el-dialog__wrapper .el-dialog.create-page-pc {
    background: none;
    box-shadow: none;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateDialog/index.vue